const endpoints = {
  createRemunerationsBonus: (): string => `remuneration/bonus`,
  showRemunerationBonus: (id: string): string => `remuneration/bonus/${id}`,
  inactivateRemunerationBonus: (id: string): string =>
    `remuneration/bonus/inactivate/${id}`,
};

export default endpoints;
